import { Navigate,Outlet } from "react-router-dom";
import {LOGIN} from "../../config/paths";
import { useAuthContext } from "../../context/authContext";

export default function PrivateRoute(){
    const {isAuth} = useAuthContext();

    if(!isAuth){
        return <Navigate to={LOGIN}/>
    }

    return (
        <div>
            <Outlet/>
        </div>
    );
}
